import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "price", })
export class PricePipe implements PipeTransform {
  transform(price: number, digits = 0): string {
    const formatter = new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: digits,
    });

    return formatter.format(price);
  }
}
